// src/components/Homepage.js
// import { Link } from "react-router-dom";
import React, { useState, useEffect } from "react";
import styles from "./Homepage.module.css";
import person1 from "../../assets/P1.jpeg";
import person2 from "../../assets/P2.jpeg";
import person3 from "../../assets/P3.jpeg";
import person4 from "../../assets/P4.jpeg";
import person5 from "../../assets/P5.jpeg";
import person6 from "../../assets/P6.jpeg";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import poster from "../../assets/poster.jpeg";

function Homepage({ hasBanner }) {
  const images = [
    "https://i.imgur.com/i9DUlij.jpeg",
    "https://i.imgur.com/Mgou2zm.jpeg",
    "https://i.imgur.com/nFOWOr2.jpeg",
    "https://i.imgur.com/aIG7BxN.jpeg",
    "https://i.imgur.com/IizaOhl.jpeg",
    "https://i.imgur.com/3YshUVp.jpeg",
    "https://i.imgur.com/GTFxVJR.jpeg",
    "https://i.imgur.com/Bejoxm3.jpeg",
    "https://i.imgur.com/0D3mcMf.jpeg",
    "https://i.imgur.com/n0rIfbS.jpeg",
    "https://i.imgur.com/w3DAnuZ.jpeg",
    "https://i.imgur.com/Dx1aOvY.jpeg",
    "https://i.imgur.com/COaYJev.jpeg",
    "https://i.imgur.com/jpI3yq9.jpeg",
    "https://i.imgur.com/qOsG0pH.jpeg",
    "https://i.imgur.com/1TqX1di.jpeg",
    "https://i.imgur.com/kHOKeEs.jpeg",
    "https://i.imgur.com/ilDmG9F.jpeg",
    "https://i.imgur.com/2UXcocd.jpeg",
    "https://i.imgur.com/P2GAna0.jpeg",
    "https://i.imgur.com/RhlG50j.jpeg",
    "https://i.imgur.com/958Xkqk.jpeg",
    "https://i.imgur.com/6CkimZL.jpeg",
    "https://i.imgur.com/7k8QNDH.jpeg",
    "https://i.imgur.com/MqQqMD0.jpeg",
    "https://i.imgur.com/b1hPhNk.jpeg",
    "https://i.imgur.com/ZfcDaN5.jpeg",
    "https://i.imgur.com/qjmaqx3.jpeg",
    "https://i.imgur.com/NHVhFfS.jpeg",
    "https://i.imgur.com/74Drvs4.jpeg",
    "https://i.imgur.com/9Sv1SZ6.jpeg",
    "https://i.imgur.com/mJWDjfY.jpeg",
    "https://i.imgur.com/RSf0vZJ.jpeg",
    "https://i.imgur.com/OLoY0np.jpeg",
    "https://i.imgur.com/Scv2Pj8.jpeg",
    "https://i.imgur.com/ZI2TpXq.jpeg",
    "https://i.imgur.com/pGTjbJZ.jpeg",
    "https://i.imgur.com/cY1KF6E.jpeg",
  ];

  const shuffleOnce = (arr) => {
    const shuffled = [...arr];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const [shuffledImages] = useState(() => shuffleOnce(images));

  const [currentIndex, setCurrentIndex] = useState(0);
  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? shuffledImages.length - 1 : prev - 1,
    );
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === shuffledImages.length - 1 ? 0 : prev + 1,
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) =>
        prev === shuffledImages.length - 1 ? 0 : prev + 1,
      );
    }, 5000);

    return () => clearInterval(interval);
  }, [shuffledImages.length]);

  return (
    <div className={styles.container}>
      <div className={styles.grid}>
        <div className={styles.gridItem}>
          <img src={person1} alt="Person 1" className={styles.image} />
        </div>
        <div className={styles.gridItem}>
          <img src={person2} alt="Person 2" className={styles.image} />
        </div>
        <div className={styles.gridItem}>
          <img src={person3} alt="Person 3" className={styles.image} />
        </div>
        <div className={styles.gridItem}>
          <img src={person4} alt="Person 4" className={styles.image} />
        </div>
        <div className={styles.gridItem}>
          <img src={person5} alt="Person 5" className={styles.image} />
        </div>
        <div className={styles.gridItem}>
          <img src={person6} alt="Person 6" className={styles.image} />
        </div>

        <div className={styles.gridItem}>
          <div className={styles.name}>Dr. N Kannaiah</div>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.name}>Manoj Kumar Parihar</div>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.name}>Shiv Gopal Mishra</div>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.name}>Mukesh Mathur</div>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.name}>JR Bhosale</div>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.name}>Mohan Das Chelani</div>
        </div>

        <div className={styles.gridItem}>
          <div className={styles.post}>
            President
            <br /> AIRF
          </div>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.post}>
            President
            <br /> NWREU
          </div>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.post}>
            General Secretary <br /> AIRF
          </div>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.post}>
            General Secretary
            <br /> NWREU
          </div>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.post}>
            Working President <br /> AIRF
          </div>
        </div>
        <div className={styles.gridItem}>
          <div className={styles.post}>
            Working President
            <br /> NWREU
          </div>
        </div>
      </div>

      {/* <Link to="/KnowYourBooth">
        <button className={styles.knowBoothBtn}>KNOW YOUR BOOTH</button>
      </Link> */}
      {/* <div style={{ textAlign: "center" }}>
        <p
          style={{
            color: "red",
            fontWeight: "bold",
            fontSize: "clamp(16px, 2.5vw, 26px)",
          }}
        >
          JCCS के डायरेक्टर के पद के चुनाव में NWREU एवं AISCTREA के संयुक्त
          उम्मीदवारो को अपना बहुमूल्य वोट देकर भारी मतों से विजयी बनाएं
        </p>

        <p>
          <a
            href="https://script.google.com/macros/s/AKfycbzyqaP6IT9pSxT9h2eeuCNDdeOdjJXMdIsx8Lae5K_5_SscqQrpxt6UgVufMZnptGk3/exec"
            style={{
              color: "blue",
              textDecoration: "underline",
              fontWeight: "bold",
              fontSize: "clamp(15px, 2vw, 24px)",
            }}
            target="_blank"
            rel="noreferrer"
          >
            मतदान केंद्र (Know Your Booth) की जानकारी के लिए यहां क्लिक करें –
            JCCS निदेशक मंडल का चुनाव
          </a>
        </p>
      </div> */}

      {/* Optional image banner */}
      {hasBanner && <img src={poster} alt="Banner" className={styles.banner} />}

      {/* Image slider */}
      <div className={styles.carousel}>
        {/* <button className={styles.prevBtn} onClick={prevImage}>
          <FaChevronLeft className={styles.icon} />
        </button>{" "} */}
        <img
          src={shuffledImages[currentIndex]}
          alt={`Image ${currentIndex + 1}`}
          className={styles.carouselImage}
          loading="lazy"
        />

        {/* <button className={styles.nextBtn} onClick={nextImage}>
          <FaChevronRight className={styles.icon} />
        </button>{" "} */}
      </div>
    </div>
  );
}

export default Homepage;
